export type ScanValueKind = 'epc' | 'barcode' | 'unknown'

/** 96-bit EPC (PC word 3000 = 6 words) = 24 hex characters. */
export const EPC_HEX_LENGTH = 24

/**
 * Classify a keyboard-wedge scan value.
 * P80 barcode and UHF buttons share one keystroke stream — pattern is mandatory.
 */
export function classifyScanValue(raw: string): ScanValueKind {
  const value = raw.trim()
  if (new RegExp(`^[0-9A-Fa-f]{${EPC_HEX_LENGTH}}$`).test(value)) return 'epc'
  if (/^\d{8,14}$/.test(value)) return 'barcode'
  return 'unknown'
}
